import { ProductsOnTheWayDataType } from '../../../../tenants/common/products-on-the-way/products-on-the-way-helpers';

export function groupProductDataByMonth() {
  return function (
    products: ProductsOnTheWayDataType[],
  ): [string, ProductsOnTheWayDataType[]][] {
    const groupedProducts = products.reduce((acc, cur) => {
      const month = new Date(cur.deliveryDate).getMonth();
      if (acc[month]) {
        acc[month] = [...acc[month], cur];
      } else {
        acc[month] = [cur];
      }
      return acc;
    }, {} as { [key: string]: ProductsOnTheWayDataType[] });
    return Object.entries(groupedProducts);
  };
}
